
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import NavMenu from '../../../components/NavMenu';
import { NavMenyItem } from '../../../components/NavMenu/types';
import DatasyncConfigPage from './Pages/Config';
import DatasyncLogsPage from './Pages/Logs';
import ContentContainer from '../../../templates/Content/ContentContainer';

const DatasyncPage: React.FC = () => {
  const { t } = useTranslation();
  const [tabSelected, setTabSelected] = useState({
    value: 'logs',
    name: 'logs',
  });

  const navMenuItems: NavMenyItem[] = [
    {
      title: t('datasyncLog'),
      action: () => setTabSelected({ value: 'logs', name: 'logs' }),
    },
    {
      title: t('datasyncConfig'),
      action: () => setTabSelected({ value: 'config', name: 'config' }),
    },
  ];

  const handleViewTab = (tabName: string) => {
    switch (tabName) {
      case 'logs':
        return <DatasyncLogsPage />;
      case 'config':
      default:
        return <DatasyncConfigPage />;
    }
  };

  return (
    <ContentContainer title={t('datasync')}>
      <NavMenu items={navMenuItems} />
      {handleViewTab(tabSelected.value)}
    </ContentContainer>
  );
};

export default DatasyncPage;
